import Loader from "@Common/Loader";
import { Provider } from "mobx-react";
import { inject, observer } from "mobx-react";

import { YMInitializer } from "react-yandex-metrika";

import Router from "./Router";

import appStore from "./stores/appStore";
import mainStore from "./stores/mainStore";

const { MODE } = import.meta.env;

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

import "./assets/scss/index.scss";

const stores = {
    appStore,
    mainStore,
};

const Root = inject("mainStore")(
    observer(({ mainStore }) => {
        const initialApp = mainStore.getMainStore("initialApp");

        const Specified = initialApp == "complete" ? Router : Loader;

        return <Specified />;
    }),
);

const ProvideStore = () => {
    return (
        <>
            <YMInitializer
                accounts={MODE === "production" ? [95339074] : [96976906]}
                version="2"
                options={{
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true,
                    trackHash: true,
                }}
            />
            <Provider {...stores}>
                <Root />
            </Provider>
        </>
    );
};

export default ProvideStore;
